module.exports = __webpack_public_path__ + "static/img/menage1a.cd5be650.png";